import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Input from 'semantic-ui-react/dist/commonjs/elements/Input';
import Icon from 'semantic-ui-react/dist/commonjs/elements/Icon';
import { SEE_MORE_LESS_CHAR_LENGTH } from '../../utils/constants';
import ReadMoreLess from '../read-more-less/ReadMoreLess';
function CheckboxGenerator(props) {
  const { label, name, disabled, validations, className, onChange } = props;
  const characterLength = props.characterLength ? props.characterLength : null;
  return (
    <div className={'check-box-wrapper ' + className + (disabled ? ' disabled' : '')}>
      <Field
        name={name}
        id={name.replace(/[._]/g, '-').toLowerCase()}
        component={Input}
        type="checkbox"
        className={props.checked ? 'checked' : ''}
        disabled={disabled}
        validate={validations || null}
        onChange={onChange || null}
      />
      {props.checked ? <Icon name="checkmark" className={disabled ? 'disabled' : ''} /> : null}
      <label
        htmlFor={name.replace(/[._]/g, '-').toLowerCase()}
        id={name.replace(/[._]/g, '-').toLowerCase() + '-label'}
      >
        {label && label.length > (characterLength ? characterLength : SEE_MORE_LESS_CHAR_LENGTH) ? (
          <ReadMoreLess content={label} characterLength={characterLength} />
        ) : (
          <p>{label}</p>
        )}
      </label>
    </div>
  );
}

CheckboxGenerator.propTypes = {
  label: PropTypes.any,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  characterLength: PropTypes.number,
  checked: PropTypes.any,
  validations: PropTypes.array,
  className: PropTypes.string,
  onChange: PropTypes.func
};

export default CheckboxGenerator;

export class StateFullCheckbox extends React.Component {
  state = {
    checked: false
  };

  componentDidMount() {
    this.setState({ checked: this.props.checked });
  }

  _toggleCheckBox = () => {
    this.setState({ checked: !this.state.checked });
    this.props.onChange && this.props.onChange();
    this.props.onValueChange && this.props.onValueChange();
  };

  render() {
    const { label, name, disabled, validations, className } = this.props;
    const { checked } = this.state;
    return (
      <div className={'check-box-wrapper ' + className + (disabled ? ' disabled' : '')}>
        <Field
          name={name}
          id={name.replace(/[._]/g, '-').toLowerCase()}
          component={Input}
          type="checkbox"
          className={checked ? 'checked' : ''}
          disabled={disabled}
          validate={validations || null}
          onChange={this._toggleCheckBox}
        />
        {checked ? <Icon name="checkmark" className={disabled ? 'disabled' : ''} /> : null}
        <label
          htmlFor={name.replace(/[._]/g, '-').toLowerCase()}
          id={name.replace(/[._]/g, '-').toLowerCase() + '-label'}
        >
          {label && label.length > SEE_MORE_LESS_CHAR_LENGTH ? (
            <ReadMoreLess content={label} />
          ) : (
            <p>{label}</p>
          )}
        </label>
      </div>
    );
  }
}

StateFullCheckbox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  validations: PropTypes.array,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onValueChange: PropTypes.func
};
